import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        locations: {},
        currentRegion: null,
        currentDistrict: null,
        loading: false,
        snackbar: {
            text: '',
            status: false,
            timeout: 4000,
        },
    },
    mutations: {
        startLoading (state) {
            state.loading = true
        },
        stopLoading (state) {
            state.loading = false
        },
        setLocations (state, locations) {
            state.locations = locations
        },
        setCurrentRegion(state, region) {
            state.currentRegion = region
        },
        setCurrentDistrict (state, districtId) {
            state.currentDistrict = districtId
        },
        showAlert (state, text) {
            state.snackbar.text = text
            state.snackbar.status = true
        },
        hideAlert (state) {
            state.snackbar.text = ''
            state.snackbar.status = false
        }
    },
    getters: {
        getCurrentDistrict(state) {
            return state.currentDistrict
        },
        getCurrentRegionCaption(state) {
            return state.currentRegion
        },
        getCurrentDistrictCaption(state) {
            return state.locations[state.currentRegion][state.currentDistrict]
        },
    },
    actions: {
        
    }
})